export default __webpack_public_path__ + "static/IMG_4313-ac7a067263193e69d9a00c79a4812d8d.jpg";